import { reactive, readonly } from "vue";

import { STATUS_TYPE } from "@/utils/enums";

interface ToastMessageType {
  type: STATUS_TYPE;
  message: string;
}
interface State {
  toastMessages: ToastMessageType[];
}

const state = reactive<State>({
  toastMessages: [],
});

export function removeToast(toast: ToastMessageType): void {
  const target = state.toastMessages.indexOf(toast);
  state.toastMessages.splice(target, 1);
}

export function addToast(toast: ToastMessageType): void {
  state.toastMessages.push(toast);
  setTimeout(removeToast, 5000, toast);
}

export const app = readonly(state);
